export const DH = {
  Container: 'form-container',
  Form: 'form',
  FieldsLine: 'fields-line',

  Field: {
    Container: {
      Number: `number-field-container`,
      Expiration: `expiration-field-container`,
      CVV: `cvv-field-container`,
      HolderName: `holderName-field-container`,
      ZipCode: `postalCode-field-container`,
    },
    Label: 'field-label',
    Input: {
      Container: 'field-input-container',
      Node: 'field-input',
    },
    ErrorMessage: 'field-error-message',
    CardNetworkIcon: 'card-type-image',
    CardNetworkIconList: 'card-type-image-list',
    CVVHint: {
      Button: 'cvv-tooltip-button',
      ButtonIcon: 'cvv-tooltip-button-icon',
      Tooltip: 'cvv-tooltip',
      Image: 'cvv-image',
    },
  },
};
